import React from "react";
import {useState,useEffect} from "react";
import {useLocation,useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import {Box} from "@mui/system";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Password} from "primereact/password";
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import {Checkbox} from "primereact/checkbox";
import {confirmDialog} from "primereact/confirmdialog";
import {ConfirmDialog} from "primereact/confirmdialog";
import {BlockUI} from "primereact/blockui";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import ActivityLog from "./ActivityLog.js";
import Message from "../Helpers/Message.js";
import {fetch_url_post} from "../../Sources/js/app.js";

let oper="";

let defaultInputValues={
	id: null,
	user_name: "",
	password: "",
	confirm_password: "",
	name: "",
	role: "",
	function: "",
	observations: "",
	email: "",
	active: 1,
	allowed_sections: [],
	filter_users: "",
};

let defaultDataValues={
	usersList: [],
	usersMenuList: [],
};

let defaultDialogValues={
	openAddEdit: false,
	titleAddEdit: "",
	openChangePassword: false,
	titleChangePassword: "Schimbare parola",
	openSections: false,
	titleSections: "",
	openActivity: false,
	titleActivity: "",
};

let userRolesList=[
	{label: "Administrator",value: "admin"},
	{label: "User",value: "user"},
];

let activeList=[
	{label: "DA",value: 1},
	{label: "NU",value: 0},
];

let defaultInputError={
	disableSave: false,
	errorText: "",
};

let currentUser={};

let initialValue={};

const Users = (props) => {

	var timerId=null;
	defaultInputValues.id=(props.userId?props.userId:null);

	const [inputValues, setInputValues] = useState(defaultInputValues);
	const [dataValues, setDataValues] = useState(defaultDataValues);
	const [messageText, setMessageText] = useState(null);
	const [dataOk, setDataOk] = useState(false);
	const [dialogValues, setDialogValues] = useState(defaultDialogValues);
	const [inputError, setInputError] = useState(defaultInputError);	
	const [blockScreen, setBlockScreen] = useState(false);
	const [usersList, setUsersList] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();

	const handleChange = evt => {
		const {name, value} = evt.target;
		if(name==="user_name") {
			let found=false;
			if(dataValues.usersList.length>0) {
				dataValues.usersList.forEach(element => {
					if((value.toUpperCase()===element.name.toUpperCase())&&((value!==initialValue.name)||(!initialValue))) {
						found=true;
					}
				});
			}
			let tmp={
				disableSave: found,
				errorText: (found===true?"Utilizatorul exista deja!":""),
			}
			setInputError(tmp);
		}
		if(name==="filter_users") {
			setUsersList(dataValues.usersList.filter((user)=>((user.name.toLowerCase().indexOf(value.toLowerCase())>-1))||(value==="")));
		}
		setInputValues({...inputValues,[name]:value});
	}

	const handleChecked = (evt,menu_id) => {
        let allowed_sections = [...inputValues.allowed_sections];
		if(evt.checked) {
            allowed_sections.push(menu_id);
        }else{
            allowed_sections.splice(allowed_sections.indexOf(menu_id),1);
		}
		setInputValues({...inputValues,allowed_sections:allowed_sections});
	}	
	
	const handleCheckedSpecial = (evt) => {
		const {name, checked} = evt.target;
		if(checked) {
			setInputValues({...inputValues,[name]:1});
		}else{
			setInputValues({...inputValues,[name]:0});
		}
	}	

	const handleButton = (evt,what,elementData) => {
		if(what==="add") {
			setInputValues(defaultInputValues);
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Adaugare utilizator"});
			setInputError(defaultInputError);
		}
		if(what==="edit") {
			setInputValues(elementData);
			initialValue=elementData;
			setDialogValues({...dialogValues,openAddEdit: true,titleAddEdit: "Editare utilizator"});
			setInputError(defaultInputError);
		}
		if(what==="password") {
				currentUser={...elementData};
				setInputValues({...inputValues,id: elementData.id,password: "",confirm_password: ""});
				setDialogValues({...dialogValues,openChangePassword: true,titleChangePassword: "Schimbare parola: "+elementData.name});
		}
		if(what==="activity") {
			currentUser={...elementData};
			setDialogValues({...dialogValues,openActivity: true,titleActivity: "Log utilizator"});
		}
		if(what==="delete") {
			let url="deleteUser";
			url+="?session_id="+props.session.sessId;
			oper="delete";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.user_name==="") {
				setMessageText("Eroare: completati campul nume de utilizator!");				
				document.getElementById("user_name").classList.add("required_input_error")
				return false;
			}
			if(inputValues.name==="") {
				setMessageText("Eroare: completati campul nume!");				
				document.getElementById("name").classList.add("required_input_error")
				return false;
			}
			if(inputValues.role==="") {
				setMessageText("Eroare: completati campul tip utilizator!");				
				document.getElementById("role").classList.add("required_input_error")
				return false;
			}
			if(inputValues.email!=="") {
				if((inputValues.email.indexOf("@")===-1)||(inputValues.email.indexOf(".")===-1)) {
					setMessageText("Eroare: completati campul email!");				
					document.getElementById("email").classList.add("required_input_error")
					return false;
				}
			}
			if(inputValues.password==="") {
				setMessageText("Eroare: completati campul parola!");				
				document.getElementById("password").classList.add("required_input_error")
				return false;
			}
			if(inputValues.confirm_password==="") {
				setMessageText("Eroare: completati campul confirmare parola!");				
				document.getElementById("confirm_password").classList.add("required_input_error")
				return false;
			}
			if(inputValues.password!==inputValues.confirm_password) {
				setMessageText("Eroare: Parola si confirmarea parolei nu sunt identice!");				
				document.getElementById("password").classList.add("required_input_error");
				document.getElementById("confirm_password").classList.add("required_input_error");
				return false;
			}
			let url="saveUser";
			url+="?session_id="+props.session.sessId;
			oper="save";
			let data={...inputValues};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_password") {
			document.querySelectorAll("input").forEach((element)=>element.classList.remove("required_input_error"));
			if(inputValues.password==="") {
				setMessageText("Eroare: completati campul parola!");				
				document.getElementById("password").classList.add("required_input_error");
				return false;
			}
			if(inputValues.confirm_password==="") {
				setMessageText("Eroare: completati campul confirmare parola!");				
				document.getElementById("confirm_password").classList.add("required_input_error");
				return false;
			}
			if(inputValues.password!==inputValues.confirm_password) {
				setMessageText("Eroare: Parola si confirmarea parolei nu sunt identice!");				
				document.getElementById("password").classList.add("required_input_error");
				document.getElementById("confirm_password").classList.add("required_input_error");
				return false;
			}
			let url="saveUserPassword";
			url+="?session_id="+props.session.sessId;
			oper="save_password";
			let data={...inputValues, id: currentUser.id};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="sections") {
			setInputValues({...inputValues,elementData});
			currentUser=elementData;
			let url="getUserMenuList";
			url+="?session_id="+props.session.sessId;
			oper="get_user_menu_list";
			let data={
				id: elementData.id,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
		}
		if(what==="save_sections") {
			let url="saveUserMenuList";
			url+="?session_id="+props.session.sessId;
			oper="save_user_menu_list";
			let data={
				id: currentUser.id,
				menu_sections: inputValues.allowed_sections,
			};
			timerId=fetch_url_post(url,data,success_handler,fail_handler,wait_handler);
			currentUser={};
		}
		if(what==="null") {
			navigate("/login");			
		}
	}

	const success_handler = (result) => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
			setMessageText("");
		}
		if(result.ok===0) {
			setMessageText("Error: "+result.error);
			return false;
		}
		if(result.is_auth===0) {
			navigate("/login");			
			return false;
		}
		if(result.message) {
			setMessageText(result.message);			
		}
		if((oper==="get")||(oper==="save")||(oper==="delete")) {
			setDialogValues(defaultDialogValues);
			setDataValues({...dataValues,usersList:(result.usersList?result.usersList:[])});
			setUsersList(result.usersList?result.usersList:[]);
            if(!dataOk) {
                setDataOk(true);
            }
			oper="";
		}
		if(oper==="save_password") {
			setDialogValues(defaultDialogValues);
			oper="";
		}
		if(oper==="get_user_menu_list") {
			setDataValues({...dataValues,usersMenuList:(result.data?result.data:[])});
			let allowed_sections=[];
			result.data.forEach(element=>{
				if(element.allowed===1) {
					allowed_sections.push(element.id);
				}
			});
			currentUser.allowed_sections=allowed_sections;
			setInputValues(currentUser);
			setDialogValues({...dialogValues,openSections: true,titleSections: "Sectiuni utilizator"});
			oper="";
		}
		if(oper==="save_user_menu_list") {
			setInputValues({...inputValues,allowed_sections:[]});			
			setDialogValues({...dialogValues,openSections: false,titleSections: ""});
			oper="";
		}
	}

	const fail_handler = () => {
		setBlockScreen(false);
		if(timerId) {
			clearTimeout(timerId);
		}
		setMessageText("Eroare de conexiune. Va rugam sa incercati mai tarziu!");
	}

	const wait_handler = () => {
		setBlockScreen(true);
		setMessageText("Operatiunea este in curs...");
	}

	useEffect(() => {
		if(props.session.sessId) {
			oper="get";
			let url="getUsers";
			url+="?session_id="+props.session.sessId;
			let data={};
			fetch_url_post(url,data,success_handler,fail_handler);
		}else{
			navigate("/login");
		}
	},[props.session.sessId]);

	const addEditDialog = () => {
		if(inputValues.id) {
			return(
                <Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med">
					<Grid container spacing={1} style={{"paddingTop":"12px"}}>
						<Grid item xs={12} sm={12} md={12} lg={6} className="field padding-med">
							<label htmlFor="user_name">Nume de utilizator*</label>
							<InputText name="user_name" id="user_name" style={{"width":"100%"}} value={inputValues.user_name} disabled={true}/>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={6} className="field padding-med">
							<label htmlFor="name">Nume si prenume*</label>
							<InputText name="name" id="name" style={{"width":"100%"}} value={inputValues.name} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
							<label htmlFor="function">Functie</label>
							<InputText name="function" id="function" style={{"width":"100%"}} value={inputValues.function} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={6} className="field padding-med">
							<label htmlFor="email">Adresa Email*</label>
							<InputText name="email" id="email" style={{"width":"100%"}} value={inputValues.email} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={6} sm={6} md={6} lg={4} className="field padding-med">
							<label htmlFor="role">Tip utilizator*</label>
							<Dropdown name="role" id="role" style={{"width":"100%"}} options={userRolesList} value={inputValues.role} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={6} sm={6} md={6} lg={2} className="field padding-med">
							<label htmlFor="active">Activ</label>
							<Dropdown name="active" id="active" style={{"width":"100%"}} options={activeList} value={inputValues.active} onChange={(evt) => handleChange(evt)}/>
						</Grid>						
						<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"21px"}}>
							<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
								{inputError.errorText}
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
							<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
							<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
						</Grid>
					</Grid>
				</Dialog>
			);
		}else{
			return(
                <Dialog header={dialogValues.titleAddEdit} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})} className="responsive-dialog-med">
					<Grid container spacing={1} style={{"paddingTop":"12px"}}>
						<Grid item xs={12} sm={12} md={12} lg={6} className="field padding-med">
							<label htmlFor="user_name">Nume de utilizator*</label>
							<InputText name="user_name" id="user_name" style={{"width":"100%"}} value={inputValues.user_name} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={6} className="field padding-med">
							<label htmlFor="name">Nume si prenume*</label>
							<InputText name="name" id="name" style={{"width":"100%"}} value={inputValues.name} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={12} className="field padding-med">
							<label htmlFor="function">Functie</label>
							<InputText name="function" id="function" style={{"width":"100%"}} value={inputValues.function} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={6} className="field padding-med">
							<label htmlFor="email">Adresa Email*</label>
							<InputText name="email" id="email" style={{"width":"100%"}} value={inputValues.email} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={6} sm={6} md={6} lg={4} className="field padding-med">
							<label htmlFor="role">Tip utilizator*</label>
							<Dropdown name="role" id="role" style={{"width":"100%"}} options={userRolesList} value={inputValues.role} onChange={(evt) => handleChange(evt)}/>
						</Grid>
						<Grid item xs={6} sm={6} md={6} lg={2} className="field padding-med">
							<label htmlFor="active">Activ</label>
							<Dropdown name="active" id="active" style={{"width":"100%"}} options={activeList} value={inputValues.active} onChange={(evt) => handleChange(evt)}/>
						</Grid>						
						<Grid item xs={12} sm={12} md={6} lg={6} className="field padding-med">
							<label htmlFor="password">Parola*</label>
							<Password name="password" id="password" style={{"width":"100%"}} value={inputValues.password} onChange={(evt) => handleChange(evt)} feedback={false} toggleMask/>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={6} className="field padding-med">
							<label htmlFor="confirm_password">Confirmare parola*</label>
							<Password name="confirm_password" id="confirm_password" style={{"width":"100%"}} value={inputValues.confirm_password} onChange={(evt) => handleChange(evt)} feedback={false} toggleMask/>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={7} style={{"textAlign":"left","marginTop":"12px"}}>
							<div style={{"color":"#FF0000","fontWeight":"600","paddingTop":"0px"}}>
								{inputError.errorText}
							</div>
						</Grid>
						<Grid item xs={12} sm={12} md={12} lg={5} style={{"textAlign":"right","marginTop":"12px"}}>
							<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save")} disabled={inputError.disableSave}/>
							<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openAddEdit:false})}/>
						</Grid>
					</Grid>
				</Dialog>
			);
		}
	}

	const changePasswordDialog = () => {
		return(
			<Dialog header={dialogValues.titleChangePassword} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openChangePassword:false})} className="responsive-dialog-small">
				<Grid container spacing={1} style={{"paddingTop":"12px"}}>
					<Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="field padding-med">
						<label htmlFor="password">Parola</label>
						<Password id="password" name="password" autoComplete="chrome-off" style={{"width":"100%"}} value={inputValues.password} onChange={(evt) => handleChange(evt)} feedback={false} toggleMask/>
					</Grid>
					<Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="field padding-med">
						<label htmlFor="confirm_password">Confirmare parola</label>
						<Password id="confirm_password" name="confirm_password" autoComplete="chrome-off" style={{"width":"100%"}} value={inputValues.confirm_password} onChange={(evt) => handleChange(evt)} feedback={false} toggleMask/>
					</Grid>
					<Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_password")}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openChangePassword:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const sectionsDialog = () => {
		return(
			<Dialog header={dialogValues.titleSections} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openSections:false})} className="responsive-dialog-med-small" contentStyle={{"paddingBottom":"15px"}}>
				<Grid container spacing={1} style={{"paddingTop":"12px"}}>
					{dataValues.usersMenuList && dataValues.usersMenuList.map((menu) => 
						<Grid item xs={12} sm={12} md={12} lg={6} key={menu.id}>
								<label htmlFor={menu.id} style={(inputValues.allowed_sections.indexOf(menu.id)===-1?{"float":"left","marginLeft":"30px","marginTop":"6px"}:{"float":"left","marginLeft":"30px","fontWeight":"600","marginTop":"6px"})}>{menu.name}</label>
								<p style={{"float":"right","textAlign":"center","marginRight":"48px"}}>
									<Checkbox name="sections" id={menu.id} onChange={(evt) => handleChecked(evt,menu.id)} checked={(inputValues.allowed_sections.indexOf(menu.id)>-1?true:false)}></Checkbox>
								</p>
						</Grid>
					)}
					<Grid item xs={12} style={{"textAlign":"right","marginTop":"12px"}}>
						<Button label="Salveaza" icon="pi pi-check-circle" className="p-button-sm p-button-success p-button-raised" style={{"marginRight":"6px"}} onClick={(evt) => handleButton(evt,"save_sections")}/>
						<Button label="Inchide" icon="pi pi-times" className="p-button-sm p-button-danger p-button-raised" onClick={(evt)=>setDialogValues({...dialogValues,openSections:false})}/>
					</Grid>
				</Grid>
			</Dialog>
		);
	}

	const activityDialog = () => {
		return(
			<Dialog header={dialogValues.titleActivity} visible={true} onHide={(evt)=>setDialogValues({...dialogValues,openActivity:false})} className="responsive-dialog-big" contentStyle={{"paddingBottom":"15px","minHeight":"750px"}}>
				<ActivityLog session={props.session} user={currentUser}/>
			</Dialog>
		);
	}

	const tableColTemplate = (row_data,column) => {
		if(column.field==="buttons") {
			if(row_data.user_name!=="administrator1") {
				return(
					<span>
						<Button label="Parola" icon="pi pi-key" tooltip="Schimbare parola" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"password",row_data)}/>
						<Button label="Modificare" icon="pi pi-pencil" tooltip="Editare utilizator" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"edit",row_data)}/>
						<Button label="Sectiuni" icon="pi pi-qrcode" tooltip="Permisiuni utilizator" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"sections",row_data)}/>
						<Button label="Log" icon="pi pi-list" tooltip="Activitate utilizator" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"activity",row_data)}/>
						<Button label="Stergere" icon="pi pi-trash" tooltip="Stergere utilizator" className="p-button-sm p-button-raised p-button-danger" onClick={(evt) => confirm(evt,"delete",row_data)}/>
					</span>
				);
			}else{
				return(
					<span>
						<Button label="Parola" icon="pi pi-key" tooltip="Schimbare parola" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"password",row_data)}/>
						<Button label="Modificare" icon="pi pi-pencil" tooltip="Editare utilizator" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} disabled={true} onClick={(evt) => handleButton(evt,"null",row_data)}/>
						<Button label="Sectiuni" icon="pi pi-qrcode" tooltip="Permisiuni utilizator" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} disabled={true} onClick={(evt) => handleButton(evt,"null",row_data)}/>
						<Button label="Log" icon="pi pi-list" tooltip="Activitate utilizator" className="p-button-sm p-button-raised" style={{"marginRight":"3px"}} onClick={(evt) => handleButton(evt,"activity",row_data)}/>
						<Button label="Stergere" icon="pi pi-trash" tooltip="Stergere utilizator" className="p-button-sm p-button-raised p-button-danger" disabled={true} onClick={(evt) => confirm(evt,"null",row_data)}/>
					</span>
				);
			}
		}
	}

	const confirm = (evt,what,elementData) => {
		if(what==="delete") {
			confirmDialog({
				message: "Sigur doriti stergerea?",
				header: "Confirmare stergere",
				icon: "pi pi-exclamation-triangle",
				accept: () => handleButton(evt,what,elementData),
				reject: () => null,
			});
		}
	}

	if(dataOk) {
		return(
			<BlockUI blocked={blockScreen} fullScreen>
				<div>
					<Grid container spacing={1} style={{}}>
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med">
							<InputText name="filter_users" id="filter_users" autoComplete="chrome-off" style={{"width":"100%"}} value={inputValues.filter_users} placeholder="Cauta utilizator..." onChange={(evt) => handleChange(evt)}/>							
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={6} xl={6} className="field padding-med text-left">
							<h6 style={{"marginTop":"9px","color":"#000000"}}>{usersList.length} {(((usersList.length>1)||(usersList.length===0))?" inregistrari gasite.":" inregistrare gasita.")}</h6>
						</Grid>						
						<Grid item xs={12} sm={4} md={4} lg={3} xl={3} className="field padding-med text-right">
							<Button label="Adaugare utilizator" icon="pi pi-plus-circle" className="p-button-sm p-button-primary" tooltip="Adaugare utilizator" style={{}} onClick={(evt) => {handleButton(evt,"add")}}/>
						</Grid>						
					</Grid>
					<Box sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block", xl: "block" } }}>
						<div className="card">
							<DataTable
								value={usersList}
								scrollable
								scrollHeight="60vh"
								style={{"minHeight":"63vh"}}
								scrollDirection="both"
								stripedRows
								resizableColumns
								columnResizeMode="fit"
								responsiveLayout="stack"
								emptyMessage="Nu exista inregistrari"
							>
								<Column field="name" header="Nume si prenume" style={{"flexGrow":"1","flexBasis":"125px"}} sortable></Column>
								<Column field="user_name" header="Nume de utilizator" style={{"flexGrow":"1","flexBasis":"120px"}} sortable></Column>
								<Column field="reg_date_parsed" header="Data crearii" style={{"flexGrow":"1","flexBasis":"40px"}} sortable></Column>
								<Column field="role" header="Tip utilizator" style={{"flexGrow":"1","flexBasis":"60px"}} sortable></Column>
								<Column field="buttons" header="Operatiuni" style={{"flexGrow":"0","flexBasis":"462px"}} body={tableColTemplate}></Column>
							</DataTable>
						</div>
					</Box>
					<Box sx={{ display: { xs: "block", sm: "block", md: "none", lg: "none", xl: "none" } }}>

					</Box>
				</div>
				<ConfirmDialog />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
				{dialogValues.openAddEdit && addEditDialog()}
				{dialogValues.openChangePassword && changePasswordDialog()}
				{dialogValues.openSections && sectionsDialog()}
				{dialogValues.openActivity && activityDialog()}
            </BlockUI>
		);
	}else{
		return(
			<React.Fragment>
				<LinearProgress />
				{messageText && <Message text={messageText} closeHandler={()=>setMessageText(null)}/>}
			</React.Fragment>
		);		
	}
};

export default Users;
